"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalFiltration = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _SelectAddress = require("./SelectAddress");
var _SelectPwhC = require("./SelectPwhC");
var _selectors = require("../../redux/selectors");
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const GlobalFiltration = exports.GlobalFiltration = /*#__PURE__*/(0, _react.memo)(() => {
  const circulationGroupsLength = (0, _reactRedux.useSelector)(_selectors.selectPwhCListLength);
  const buildingsLength = (0, _reactRedux.useSelector)(_selectors.selectBuildingsLength);
  const hidePanel = circulationGroupsLength <= 1 && buildingsLength <= 1;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: 'grid',
      gridTemplateRows: '1fr',
      gap: '0 40px',
      gridTemplateColumns: 'repeat(auto-fit,364px)',
      transition: "all ".concat(_constants.styles.transitionType.secondary),
      height: hidePanel ? 0 : 40,
      overflowY: 'hidden',
      mb: hidePanel ? 0 : 5,
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement(_SelectAddress.SelectAddress, null), /*#__PURE__*/_react.default.createElement(_SelectPwhC.SelectPwhC, null));
});